module.exports = __webpack_public_path__ + "img/rencairight.1b3a8268.png";